<template>
  <div>
    <profile/>
  </div>
</template>

<script>
import profile from '@/components/_manageparticipation/_overview/profile.vue'
export default {
  components: {
    profile
  }
}
</script>

<style scoped>
</style>
